import React from "react";
import styled from "styled-components";
import Box from "../../../components/Box";
import UserAvatar from "../../../components/UserAvatar";
import { Colors, TextFont } from "../../../config";

const editIcon = require("../../../assets/images/Edit.png");

const SelectedFlightDetailBox = ({ onEditClick }) => {
  return (
    <Box boxColor={Colors.brandTwoOpacity80} boxBorder="0rem">
      <DetailContainer>
        <PhotoAndName>
          <UserAvatar />
          <TextFont fontColor={Colors.white} fontWeight="700">
            Wasim Yousuf Rahiman
          </TextFont>
        </PhotoAndName>
        <FromToWrapper>
          <span>Departure: </span>
          Doha DOH - Dubai DXB
          <div>Fly Dubai (001232) | Feb 24 </div>
        </FromToWrapper>
        <FromToWrapper>
          <span> Return: </span>
          Dubai DXB - Doha DOH
          <div>Fly Dubai (002234) | Mar 16 </div>
        </FromToWrapper>
        <TextFont
          fontColor={Colors.brandOne}
          fontWeight="700"
          fontSize="1.625rem"
        >
          546 QAR
        </TextFont>
        <EditImg src={editIcon} alt="edit" onClick={onEditClick} />
      </DetailContainer>
    </Box>
  );
};

export default SelectedFlightDetailBox;

const DetailContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem 2.625rem;
  align-items: center;
  margin-bottom: 1rem;
`;
const PhotoAndName = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
const FromToWrapper = styled.div`
  font-size: 1.125rem;
  font-weight: 600;
  color: ${Colors.ebonyClay};
  > span {
    color: ${Colors.white};
  }
`;
const EditImg = styled.img`
  padding: 0.5rem;
  background-color: ${Colors.white};
  border-radius: 50%;
  cursor: pointer;
`;
